import styled from 'styled-components';
import { black, white } from '@avangard/ui/colors';

type StudentOnlineApplicationBlockProps = {
    children?: React.ReactNode;
    title?: React.ReactNode;
    description?: React.ReactNode;
    className?: string;
};

const StudentOnlineApplicationBlock = (
    props: StudentOnlineApplicationBlockProps,
): React.ReactElement => {
    const { title, description, children, className } = props;

    const hasHeader = !!title || !!description;

    return (
        <Root className={className}>
            {hasHeader ? (
                <Header>
                    <h3>{title ? title : null}</h3>

                    {description ? description : null}
                </Header>
            ) : null}

            {hasHeader ? <Main>{children}</Main> : children}
        </Root>
    );
};

const Root = styled.div`
    padding: 32px;
    background: ${white[100]};
`;

const Header = styled.div`
    > h3 {
        color: ${black[80]};
        font-size: 2.4rem;
        font-weight: 600;
    }

    > p {
        margin-top: 8px;

        color: ${black[54]};
        font-size: 1.4rem;
        font-weight: 600;
    }
`;

const Main = styled.div`
    margin-top: 24px;
`;

export { StudentOnlineApplicationBlock };
